import React, { useCallback } from 'react';

import { Fold } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useClearPolicyFilters } from '../hooks';
import { useLicense } from '../LicenseProvider';
import GenericPolicySubForm from './GenericPolicySubForm';
import { TTLSelectField } from './TTLSelectField/TTLSelectField';

function BodySamplePolicySubForm() {
  const { isFeatureAvailable } = useLicense();
  const isBodyLicenseAvailable = isFeatureAvailable('estimations.body_attributes');
  const { t } = useTranslation();
  const { control } = useFormContext();
  const bodySamplePolicyIsEnabled = useWatch({ name: 'bodySamplePolicy.isEnabled' });

  useClearPolicyFilters('bodySamplePolicy', {
    on: useCallback(() => bodySamplePolicyIsEnabled === false, [bodySamplePolicyIsEnabled]),
  });

  return (
    <Fold
      control={control}
      disabled={!isBodyLicenseAvailable}
      isOpen={!!isBodyLicenseAvailable && bodySamplePolicyIsEnabled}
      name="bodySamplePolicy.isEnabled"
      switch
      testId="bodySamplePolicy"
      title={t('handlers:setup sections.save body image')}
    >
      <GenericPolicySubForm fieldName="bodySamplePolicy.filters">
        <TTLSelectField fieldName="bodySamplePolicy" />
      </GenericPolicySubForm>
    </Fold>
  );
}

export default BodySamplePolicySubForm;
